module.exports = "/_next/static/main.css?2G03rYo";